export const FuneralClaimDecisions = [
    { value: 'Approve', label: 'Pay' },
    { value: 'Defer', label: 'No Claim' },
    { value: 'Decline', label: 'Repudiate' },
];

export const DeferredFuneralClaimDecisions = [
    { value: 'Defer', label: 'Claim is referred to FNB' },
];
